import { call, cancelled, put, take, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import moment from 'moment'
import Cookie from 'js-cookie'
import firebase from '../config/firebase'
import OrderActions from '../reducers/orderReducer'
import utils from '../utils'

const subscribe = (ref, user) =>
  eventChannel(emit => {
    const onSnapshot = snapshot => {
      const orders = {}
      const delivereeInProgressOrders = {}
      const delivererInProgressOrders = {}

      const data = snapshot.val()

      if (data) {
        const snapshotData = Object.values(data)
        const snapshotKeys = Object.keys(data)

        for (let i = 0; i < snapshotData.length; i+=1) {
          const key = snapshotKeys[i]
          const orderData = snapshotData[i]

          const order = { ...orderData, key }
          const isResponsibleOrder = user.role === 'operator@role' && order.current_operator === user.uid
          const orderStatus = utils.order.getOrderStatus(order)

          if (isResponsibleOrder || user.isOperatorAdmin) {
            orders[orderStatus] = orders[orderStatus] || []
            orders[orderStatus].push(order)

            orders.all = orders.all || []
            orders.all.push(order)
          } else {
            orders.other = orders.other || []
            orders.other.push(order)
          }

          if (orderStatus !== 'delivered' && orderStatus !== 'rejected') {
            (delivereeInProgressOrders[order.deliveree] || (delivereeInProgressOrders[order.deliveree] = [])).push(key)

            if (order.deliverer) {
              (delivererInProgressOrders[order.deliverer] || (delivererInProgressOrders[order.deliverer] = [])).push(key)
            }
          }
        }
      }

      emit({ orders, delivereeInProgressOrders, delivererInProgressOrders })
    }

    ref.on('value', onSnapshot)

    return () => {
      ref.off('value', onSnapshot)
    }
  })

export function* syncTodayOrders() {
  const user = yield select(state => state.auth.data)
  const orderViewHours = Number(Cookie.get('order_view_hours')) || 2

  let startedAt = Number(
    moment()
      .subtract(orderViewHours, 'hours')
      .format('x')
  )

  if (orderViewHours === -1) {
    startedAt = Number(
      moment()
        .startOf('days')
        .format('x')
    )
  }

  const ref = firebase
    .database()
    .ref('orders')
    .orderByChild('created_at')
    .startAt(startedAt)

  const channel = yield call(subscribe, ref, user)

  try {
    while (true) {
      const orders = yield take(channel)

      yield put(OrderActions.setTodayOrders(orders))
    }
  } finally {
    if (yield cancelled()) {
      channel.close()
      yield put(OrderActions.syncTodayOrdersDisconnected())
    }
  }
}

export function* syncDriverPendingOrders() {
  const ref = firebase.database().ref('driver_pending_order')
  const channel = yield call(subscribe, ref)

  try {
    while (true) {
      const orders = yield take(channel)

      yield put(OrderActions.setDriverPendingOrders(orders))
    }
  } finally {
    if (yield cancelled()) {
      channel.close()
      yield put(OrderActions.syncDriverPendingOrdersDisconnected())
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/orderSaga.js